var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          style: _vm.styles,
          attrs: {
            size: _vm.size,
            filterable: "",
            multiple: _vm.multiple,
            disabled: _vm.disabled,
            placeholder: _vm.placeholder,
            clearable: "",
          },
          on: { clear: _vm.handlerClear, change: _vm.handlerChange },
          model: {
            value: _vm.val,
            callback: function ($$v) {
              _vm.val = $$v
            },
            expression: "val",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c(
            "el-option",
            {
              key: item.value,
              attrs: {
                label: item.label,
                value: item.value,
                disabled: item.disabled,
              },
            },
            [
              _c("span", { staticStyle: { float: "left" } }, [
                _vm._v(_vm._s(item.label)),
              ]),
              item.showSpan
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        float: "right",
                        color: "#8492a6",
                        "font-size": "13px",
                      },
                    },
                    [_vm._v("已删除")]
                  )
                : _vm._e(),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }